import React from "react";
import "../../css/ResourceHero.css";
import SliderTabs from "../SliderTabs";

const ResourceHero = ({ title, subtitle, image }) => {
  return (
    <section
      className="Resource-hero"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,.55), rgba(0,0,0,.55)), url(${image})`,
      }}
    >
      <div className="Resource-hero-content">
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>
      <div className="hero-slider-tabs">
        <SliderTabs />
      </div>
    </section>
  );
};

export default ResourceHero;
